import { Loader } from "shared/components/Loader";
import { EmptyPropertyGroups } from "./components/EmptyPropertyGroups";
import { PropertyGroupsTable } from "./components/PropertyGroupsTable";
import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { PROPERTY_GROUPS_QUERY_KEY } from "./constants";
import { useState } from "react";
import { useDebouncedValue } from "shared/hooks/use-debounced-value";
import { useAuthContext } from "providers/Auth";

export const PropertyGroups = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 500);
  const { type } = useAuthContext();

  const { data: config, isLoading: isLoadingConfig } = useQuery({
    queryKey: [PROPERTY_GROUPS_QUERY_KEY.CONFIG],
    queryFn: () =>
      instance.get("/portal/v1/property_groups/config").then((res) => res.data)
  });

  const {
    data: propertyGroups,
    isLoading: isLoadingPropertyGroups,
    isFetching
  } = useQuery({
    queryKey: [PROPERTY_GROUPS_QUERY_KEY.PROPERTY_GROUPS, debouncedSearchTerm],
    queryFn: () => {
      localStorage.removeItem("existing_property_groups");

      return instance
        .get("/portal/v1/property_groups", {
          params: {
            search: debouncedSearchTerm
          }
        })
        .then((res) => res.data.items);
    }
  });

  if (isLoadingPropertyGroups || isLoadingConfig)
    return (
      <div className="flex justify-center items-center h-[100vh]">
        <Loader />
      </div>
    );

  if (
    propertyGroups?.length === 0 &&
    !debouncedSearchTerm &&
    (type.isAdmin || type.isOwner)
  )
    return <EmptyPropertyGroups />;

  return (
    <PropertyGroupsTable
      availableSplitOptions={config?.split_by || []}
      propertyGroups={propertyGroups || []}
      totalProperties={
        propertyGroups?.reduce(
          (acc, group) => acc + (group.total_properties || 0),
          0
        ) || 0
      }
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      isLoading={isFetching}
    />
  );
};
